// extracted by mini-css-extract-plugin
export default {"paragraph":"P_paragraph__-Mkzj","ellipsis":"P_ellipsis__ZC-bg","hover":"P_hover__byE8V"};